export default [
    {
        title: "Latest Technology",
        text: "We utilize the most up-to-date technology to ensure the development of your store is as functional and efficient as possible."
    },
    {
        title: "Page Builders",
        text: "To create an efficient experience for you, we use page builders so that you can make small edits yourself."
    },
    {
        title: "Payment Methods",
        text: "We can easily set up any payment method or app to your store. This means that you will not have to change your previous system and is much more efficient for your business practices."
    },
]